export const chatSchemaSkill = ({ organizationId, skillName }) => {
  const apiBase = process.env.VITE_API_BASE.replace(/\/$/, '');
  const params = new URLSearchParams({
    organizationId,
    skillName,
  });

  return `${apiBase}/api/agents/skill-chat?${params.toString()}`;
};
